import { createContext } from 'react';
import { StructureCopyContextProps } from './types';

export const StructureCopyContext = createContext<StructureCopyContextProps | undefined>(undefined);
